var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { WPQTCard } from "../../components/Card/Card";
import { TaskCardActions } from "../../components/Card/TaskCardActions";
import { UserAssignementDropdown } from "../../components/Dropdown/UserAssignementDropdown/UserAssignementDropdown";
import { UserTaskDropdown } from "../../components/Dropdown/UserTaskDropdown/UserTaskDropdown";
import { NoFilterResults } from "../../components/Filter/NoFilterResults/NoFilterResults";
import { TaskModal } from "../../components/Modal/TaskModal/TaskModal";
import { ADD_ASSIGNED_USER_TO_USER_TASK, CHANGE_USER_TASK_DONE_STATUS, EDIT_USER_TASK, OPEN_EDIT_TASK_MODAL, REMOVE_ASSIGNED_USER_FROM_USER_TASK, REMOVE_USER_TASK, } from "../../constants";
import { useTaskActions } from "../../hooks/actions/useTaskActions";
import { useUserTasksFilter } from "../../hooks/filters/useUserTasksFilter";
import { ModalContext } from "../../providers/ModalContextProvider";
import { UserTasksContext } from "../../providers/UserTasksContextProvider";
function UserTasks({ userId }) {
    var _a;
    const { filterTasks } = useUserTasksFilter();
    const { modalDispatch } = useContext(ModalContext);
    const { state: { tasks }, userTasksDispatch, } = useContext(UserTasksContext);
    const { removeTaskFromUser } = useTaskActions();
    const filteredTasks = (_a = tasks === null || tasks === void 0 ? void 0 : tasks.filter(filterTasks)) !== null && _a !== void 0 ? _a : [];
    const unAssignTask = (taskId) => __awaiter(this, void 0, void 0, function* () {
        removeTaskFromUser(userId, taskId, () => {
            userTasksDispatch({ type: REMOVE_USER_TASK, payload: taskId });
        });
    });
    const onEditTaskCallback = (task) => {
        userTasksDispatch({ type: EDIT_USER_TASK, payload: task });
    };
    if (tasks && tasks.length === 0) {
        return _jsx(NoFilterResults, { text: __("User has no tasks", "quicktasker") });
    }
    if (filteredTasks && filteredTasks.length === 0) {
        return _jsx(NoFilterResults, {});
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: "wpqt-card-grid", children: filteredTasks.map((task) => {
                    return (_jsxs(WPQTCard, { className: "wpqt-cursor-pointer", title: task.name, description: task.description, dropdown: _jsx(UserTaskDropdown, { taskId: task.id, onUnAssignTask: unAssignTask }), onClick: () => {
                            modalDispatch({
                                type: OPEN_EDIT_TASK_MODAL,
                                payload: { taskToEdit: task },
                            });
                        }, children: [_jsx(UserAssignementDropdown, { task: task, onUserAdd: (user) => {
                                    userTasksDispatch({
                                        type: ADD_ASSIGNED_USER_TO_USER_TASK,
                                        payload: { taskId: task.id, user },
                                    });
                                }, onUserDelete: (user) => {
                                    userTasksDispatch({
                                        type: REMOVE_ASSIGNED_USER_FROM_USER_TASK,
                                        payload: { taskId: task.id, user },
                                    });
                                } }), _jsx(TaskCardActions, { task: task, onDoneStatusChange: (taskId, done) => {
                                    userTasksDispatch({
                                        type: CHANGE_USER_TASK_DONE_STATUS,
                                        payload: { taskId, done },
                                    });
                                } })] }, task.id));
                }) }), _jsx(TaskModal, { editTaskCallback: onEditTaskCallback })] }));
}
export { UserTasks };
